/* Homepage.js */

import React from 'react';
import { Container, Row } from 'reactstrap';

export default function Homepage() {
  return (
    <Container>
      <Row>
        
      </Row>
    </Container>
  );
}
